<template>
  <a-card :loading="loading" :body-style="{padding: '24px 32px'}" :bordered="false">
    <div class="an-title clearfix">
      <h1>{{ message.title }}</h1>
      <p>{{ message.gmtCreate }}</p>
    </div>
    <div class="an-content" v-html="message.content"/>
  </a-card>
</template>

<script>
import { decrypt } from '@/utils/util'
import { getMessage } from '@/api/message'

export default {
  data () {
    return {
      loading: false,
      id: null,
      message: {
        id: '',
        type: '',
        title: '',
        content: '',
        gmtCreate: null
      }
    }
  },

  mounted () {
    if (this.$route.query.id) {
      this.id = this.decrypt(this.$route.query.id)
      this.fetchData()
    } else {
      this.$router.go(-1)
    }
  },

  methods: {
    decrypt,
    fetchData () {
      this.loading = true
      getMessage(this.id).then(response => {
        this.message = response.data
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .an-title {
    text-align: center;
  }

  .an-content {
    margin-top: 20px;
  }
</style>
